<template>
  <div class="mb-5">
    <div class="subheader py-3 py-lg-3 subheader-transparent transparent">
      <div
        class="
          d-flex
          align-items-center
          justify-content-between
          flex-wrap flex-sm-nowrap
          container-fluid
          p-0
        "
      >
        <div class="d-flex align-items-baseline mr-5 mb-5">
          <h3 class="subheader-title text-dark font-weight-bold my-2 mr-3">
            Summary Report
          </h3>
        </div>
        <div class="d-flex align-items-center">
          <a
            :href="linkDownloadHarian()"
            target="_blank"
            class="btn btn-sm btn-success font-weight-bold"
          >
            Download data harian
          </a>
          <a
            :href="linkDownload()"
            target="_blank"
            class="btn btn-sm btn-danger font-weight-bold ml-3"
          >
            Download data kumulatif
          </a>
        </div>
      </div>
    </div>

    <b-row>
      <!-- kolom 1 -->
      <b-col>
        <!--begin::Stats Widget-->
        <div
          class="card card-custom bgi-no-repeat card-stretch gutter-b stat"
          :style="{ backgroundImage: 'url(' + image + ')' }"
        >
          <!--begin::Body-->
          <div class="card-body my-4">
            <a
              href="#"
              class="
                card-title
                font-weight-bolder
                text-dark-50
                font-size-h6
                mb-4
                text-hover-state-dark
                d-block
              "
            >
              INDONESIA: CAKUPAN DOSIS 1
            </a>
            <div class="font-weight-bold text-muted font-size-sm">
              <span
                class="text-dark-75 font-weight-bolder font-size-h2 mr-2"
                v-if="getNationalCoverageDose1()"
              >
                {{ getNationalCoverageDose1() }}%
              </span>
              Cakupan
            </div>
            <div class="progress progress-sm mt-7 bg-success-o-60">
              <div
                class="
                  progress-bar progress-bar-striped progress-bar-animated
                  bg-success
                "
                role="progressbar"
                :style="{ width: getNationalCoverageDose1() + '%' }"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
            <div
              class="separator separator-dashed separator-border-2 mt-5 mb-5"
            />
            <div class="text-dark-50 font-size-h6 mt-5">
              <b class="text-primary font-weight-bolder">
                {{ progressNationalDose1 }}
              </b>
              capaian dari
              <b class="text-primary font-weight-bolder">
                {{ getTargetNational() }}
              </b>
              sasaran
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Stats Widget-->
      </b-col>
      <!-- end kolom 1 -->

      <!-- kolom 2 -->
      <b-col>
        <!--begin::Stats Widget-->
        <div
          class="card card-custom bgi-no-repeat card-stretch gutter-b stat"
          :style="{ backgroundImage: 'url(' + image + ')' }"
        >
          <!--begin::Body-->
          <div class="card-body my-4">
            <a
              href="#"
              class="
                card-title
                font-weight-bolder
                text-dark-50
                font-size-h6
                mb-4
                text-hover-state-dark
                d-block
              "
            >
              INDONESIA: CAKUPAN DOSIS 2
            </a>
            <div class="font-weight-bold text-muted font-size-sm">
              <span
                class="text-dark-75 font-weight-bolder font-size-h2 mr-2"
                v-if="getNationalCoverageDose2()"
              >
                {{ getNationalCoverageDose2() }}%
              </span>
              Cakupan
            </div>
            <div class="progress progress-sm mt-7 bg-success-o-60">
              <div
                class="
                  progress-bar progress-bar-striped progress-bar-animated
                  bg-success
                "
                role="progressbar"
                :style="{ width: getNationalCoverageDose2() + '%' }"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
            <div
              class="separator separator-dashed separator-border-2 mt-5 mb-5"
            />
            <div class="text-dark-50 font-size-h6 mt-3">
              <b class="text-primary font-weight-bolder">
                {{ progressNationalDose2 }}
              </b>
              capaian dari
              <b class="text-primary font-weight-bolder">
                {{ getTargetNational() }}
              </b>
              sasaran
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Stats Widget-->
      </b-col>
      <!-- end kolom 2 -->

      <!-- kolom 3 -->
      <b-col>
        <!--begin::Stats Widget-->
        <div
          class="card card-custom bgi-no-repeat card-stretch gutter-b stat"
          :style="{ backgroundImage: 'url(' + image + ')' }"
        >
          <!--begin::Body-->
          <div class="card-body my-4">
            <a
              href="#"
              class="
                card-title
                font-weight-bolder
                text-dark-50
                font-size-h6
                mb-4
                text-hover-state-dark
                d-block
              "
            >
              INDONESIA: CAKUPAN DOSIS 3
            </a>
            <div class="font-weight-bold text-muted font-size-sm">
              <span
                class="text-dark-75 font-weight-bolder font-size-h2 mr-2"
                v-if="getNationalCoverageDose3()"
              >
                {{ getNationalCoverageDose3() }}%
              </span>
              Cakupan
            </div>
            <div class="progress progress-sm mt-7 bg-success-o-60">
              <div
                class="
                  progress-bar progress-bar-striped progress-bar-animated
                  bg-success
                "
                role="progressbar"
                :style="{ width: getNationalCoverageDose3() + '%' }"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
            <div
              class="separator separator-dashed separator-border-2 mt-5 mb-5"
            />
            <div class="text-dark-50 font-size-h6 mt-3">
              <b class="text-primary font-weight-bolder">
                {{ progressNationalDose3 }}
              </b>
              capaian dari
              <b class="text-primary font-weight-bolder">
                {{ getTargetNational() }}
              </b>
              sasaran
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Stats Widget-->
      </b-col>
      <!-- end kolom 3 -->

      <!-- kolom 4 -->
      <b-col>
        <!--begin::Stats Widget-->
        <div
          class="
            card card-custom
            bgi-no-repeat
            card-stretch
            gutter-b
            stat
            bg-light-warning
          "
        >
          <!--begin::Body-->
          <div class="card-body my-4">
            <a
              href="#"
              class="
                card-title
                font-weight-bolder
                text-dark-50
                font-size-h6
                mb-4
                text-hover-state-dark
                d-block
              "
            >
              CAKUPAN LAPORAN KAKO
            </a>
            <div class="font-weight-bold text-muted font-size-sm">
              <span
                class="text-dark-75 font-weight-bolder font-size-h2 mr-2"
                v-if="getDistrictCoverage()"
              >
                {{ getDistrictCoverage() }}%
              </span>
              KaKo yang sudah melapor
            </div>
            <div class="progress progress-sm mt-7 bg-success-o-60">
              <div
                class="
                  progress-bar progress-bar-striped progress-bar-animated
                  bg-success
                "
                role="progressbar"
                :style="{ width: getDistrictCoverage() + '%' }"
                aria-valuenow="50"
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
            <div
              class="separator separator-dashed separator-border-2 mt-5 mb-5"
            />
            <div class="text-dark-50 font-size-h6 mt-3">
              <b class="text-primary font-weight-bolder">
                {{ progressDistrict }}
              </b>
              KaKo melapor dari
              <b class="text-primary font-weight-bolder">
                {{ targetDistrict }}
              </b>
              sasaran
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Stats Widget-->
      </b-col>
      <!-- kolom 4 -->
    </b-row>
    <div style="margin-top: -15px">
      <span class="text-muted">
        Note:
        <b>
          Sasaran berdasarkan surat usulan revisi data sasaran lansia dan data
          sasaran vaksinasi COVID-19 tahap III dan Usia 12 - 17 Tahun
        </b>
      </span>
    </div>

    <b-row class="mt-10">
      <b-col md="3">
        <!--begin::daily report chart-->
        <div
          class="
            card card-custom
            bg-light-danger
            card-stretch card-shadowless
            mb-5
          "
        >
          <!--begin::Header-->
          <div class="card-header border-0 pt-5">
            <div class="card-title font-weight-bolder">
              <div class="card-label">
                Tanggal: {{ getToday() }}
                <div class="font-size-sm text-muted mt-2">
                  LAPORAN HARIAN KAKO
                </div>
              </div>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body">
            <!--begin::Chart-->
            <div class="outer">
              <DoughnutChart
                v-if="displaydatacollection"
                :chartData="displaydatacollection"
                class="chart-container"
              />
              <p class="percent">
                {{ absensiPercentage() }}%
                <span>melapor</span>
              </p>
            </div>
            <!--end::Chart-->

            <div class="text-dark-50 font-size-h6 mt-10">
              <!-- <a href="">Klik disini untuk lihat detil</a> -->
              <div class="font-weight-bold text-muted">
                <span class="text-danger font-weight-bolder font-size-h2 mr-2">
                  {{ getAbsensi() }}
                </span>
                KaKo belum melapor
              </div>
              <br />
              <router-link
                to="/daily_report"
                v-slot="{ href, navigate }"
                class="mt-5"
              >
                <a
                  :href="href"
                  @click="navigate"
                  class="btn btn-block btn-sm btn-danger font-weight-bold"
                >
                  Lihat Detil
                </a>
              </router-link>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::daily report chart-->
      </b-col>
      <b-col md="9">
        <b-card title="Trendline" sub-title="Progress cakupan kumulatif">
          <!-- <TrendChart /> -->
          <TrendChart2 />
        </b-card>
      </b-col>
    </b-row>

    <div class="mt-5">
      <span class="text-muted">
        Note:
        <b>Summary info</b>
      </span>
    </div>
  </div>
</template>

<script>
import { addDots, today } from '@/core/helpers/temp/util.js'
import TrendChart from '@/view/pages/home/TrendChart.vue'
import TrendChart2 from '@/view/pages/home/TrendChart2.vue'
import DoughnutChart from '@/view/components/charts/DoughnutChart'

export default {
  name: 'summary_widget',
  props: {
    cumulativeReport: Array,
    dailyReport: Array,
    targetNational: Number,
  },
  components: {
    TrendChart,
    DoughnutChart,
    TrendChart2,
  },
  data() {
    return {
      // targetNational: 208265720,
      targetNakesNational: 1468764,
      progressNationalDose1: 0,
      progressNationalDose2: 0,
      progressNationalDose3: 0,
      targetDistrict: 514,
      progressDistrict: 0,
    }
  },
  methods: {
    getNationalCoverageDose1() {
      if (this.cumulativeReport) {
        var value = this.cumulativeReport.reduce(function (accumulator, item) {
          let data =
            item.capaian_harian_dosis_1 == '-'
              ? 0
              : Number(item.capaian_harian_dosis_1)
          return accumulator + data
        }, 0)

        // save it into progress dose one
        this.progressNationalDose1 = addDots(value)

        const result = (value / this.targetNational) * 100
        return result.toFixed(1)
      }
      return false
    },
    getNationalCoverageDose2() {
      if (this.cumulativeReport) {
        var value = this.cumulativeReport.reduce(function (accumulator, item) {
          let data =
            item.capaian_harian_dosis_2 == '-'
              ? 0
              : Number(item.capaian_harian_dosis_2)
          return accumulator + data
        }, 0)

        // save it into progress dose two
        this.progressNationalDose2 = addDots(value)

        const result = (value / this.targetNational) * 100
        return result.toFixed(1)
      }
      return false
    },
    getNationalCoverageDose3() {
      if (this.cumulativeReport) {
        var value = this.cumulativeReport.reduce(function (accumulator, item) {
          let data =
            item.capaian_harian_dosis_3 == '-'
              ? 0
              : Number(item.capaian_harian_dosis_3)
          return accumulator + data
        }, 0)

        // save it into progress dose two
        this.progressNationalDose3 = addDots(value)

        const result = (value / this.targetNational) * 100
        return result.toFixed(1)
      }
      return false
    },

    // target vaksinasi
    getTargetNational() {
      return addDots(this.targetNational)
    },

    // target vaksinasi
    getTargetNakesNational() {
      return addDots(this.targetNakesNational)
    },
    getDistrictCoverage() {
      if (this.cumulativeReport) {
        var value = this.cumulativeReport.filter(function (item) {
          return item.status === 'SUDAH LAPOR'
        })

        // console.log(value.length)
        this.progressDistrict = value.length
        const result = (value.length / this.targetDistrict) * 100

        return result.toFixed(1)
      }
      return false
    },
    getAbsensi() {
      if (this.dailyReport) {
        return this.targetDistrict - this.dailyReport.length
      }
      return 514
    },
    absensiPercentage() {
      if (this.dailyReport) {
        const result = (this.dailyReport.length / this.targetDistrict) * 100
        return result.toFixed(1)
      }
      return 0
    },
    getToday() {
      return today()
    },
    linkDownload() {
      const url = process.env.VUE_APP_SERVICE_URL
      return `${url}administrator/cluster_immunization/export`
    },
    linkDownloadHarian() {
      const url = process.env.VUE_APP_SERVICE_URL
      return `${url}administrator/cluster_immunization/export_all_data`
    },
  },
  computed: {
    image() {
      const baseUrl = process.env.VUE_APP_BASE_URL
      return baseUrl + '/media/svg/shapes/abstract-4.svg'
    },

    // calling entry function
    displaydatacollection() {
      const progress = this.targetDistrict - this.getAbsensi()
      return {
        labels: ['', ''],
        datasets: [
          {
            label: 'Kesiapan',
            borderColor: '#ffe2e5',
            pointBackgroundColor: '#ffe2e5',
            borderWidth: 1,
            pointBorderColor: '#ffe2e5',
            data: [progress, this.targetDistrict],
            backgroundColor: ['#FF6384', '#faf5ef'],
            hoverBackgroundColor: ['#FF6384', '#faf5ef'],
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.stat {
  background-position: right top;
  background-size: 30% auto;
}

.outer {
  position: relative;
  width: 220px;
  height: 120px;
  text-align: center;
  margin: 0 auto;
}
.chart-container {
  position: absolute;
  width: 220px;
  height: 120px;
}
.percent {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 40px;
  bottom: -5%;
  line-height: 23px;
}

.percent span {
  font-size: 20px;
}
</style>
